import { Injector } from '@angular/core';

/** Internal global variable to access BaaS Core context. */
export const baasCoreContext: {
    /** Dependency injection container used. */
    injector: Injector;
} = {
    injector: undefined
};
